export default "__VITE_ASSET__D1plQDgd__"